<template>
  <eg-search-select
    :items="items"
    :value="value"
    :required="true"
    title-key="name"
    :filter-item-function="filterItemFunction"
    @update:search="locationAutocomplete"
    @input="selectLocation"
  />
</template>

<script>
import EgSearchSelect from "@/components/global/eg_search_select.vue";
import { getLocationAutocomplete } from "@/api";

export default {
  name: "WhereDoYouTeachStep",
  components: {
    EgSearchSelect,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      items: [],
      location: {},
    };
  },

  created() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location = position.coords;
      });
    }

    if (this.value?.id) {
      this.items.push(this.value);
    }
  },

  methods: {
    // return all items
    filterItemFunction() {
      return true;
    },

    async locationAutocomplete(query = "") {
      if (!query) {
        this.items = [];

        return;
      }

      const response = await getLocationAutocomplete(query, this.location);
      this.items = response.data;
    },

    selectLocation(item) {
      this.$emit("input", item);
    },
  },
};
</script>
